import Modal from "components/Systems/Modal/Modal";

export default Modal;
